import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from 'angularfire2/database';
import * as firebase from 'firebase';
import { User } from '../models/group';

export class BaseDbService {
  private rootPath = "/dhukuti";
  protected dbPath: string;
  CurrentUser: firebase.User;

  constructor(
    protected db: AngularFireDatabase,
    path: string) {
    this.dbPath = `${this.rootPath}/${path}`;
    if (firebase.auth().currentUser != null) {
      this.CurrentUser = firebase.auth().currentUser;
    }
  }

  getListRef(): AngularFireList<any> {
    return this.db.list(this.dbPath);
  }

  getObjectRef(): AngularFireObject<any> {
    return this.db.object(this.dbPath);
  }

  getById(id): AngularFireObject<any> {
    return this.db.object(`${this.dbPath}/${id}`);
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseDbService {
  public Id: string;
  private usersRef: AngularFireList<any> = null;
  private currentUserRef: AngularFireObject<any> = null;

  constructor(protected db: AngularFireDatabase) {
    super(db, "users");
    if (firebase.auth().currentUser != null) {
      this.usersRef = this.db.list(this.dbPath);
      this.currentUserRef = this.db.object(`${this.dbPath}/${this.CurrentUser.uid}`);
    }
  }

  add(user: User) {
    return this.db.object(`${this.dbPath}/${user.id}`).set({
      name: user.name,
      email: user.email,
      emailVerified: user.emailVerified,
      provider: user.provider
    });
  }

  setCurrentUserDetails(user: User): any {
    return this.currentUserRef.set({
      name: user.name,
      email: user.email,
      emailVerified: user.emailVerified,
      provider: user.provider
    });
  }

  getCurrentUser(): AngularFireObject<any> {
    if (firebase.auth().currentUser != null) {
      return this.db.object(`${this.dbPath}/${firebase.auth().currentUser.uid}`);
    }
    return null;
  }

  getByEmail(email: string) {
    return this.db.list(`${this.dbPath}`, ref => ref.orderByChild('email').equalTo(email)).query.once("value");
  }
}